import { LANGUAGE_CHOICES } from '../../../i18n/languages';
import type { LanguageChoice } from '../../../i18n/languages';
import type { SettingsLanguage } from '../../close-the-loop';

export type LanguageNote =
  | { readonly kind: 'none' }
  | { readonly kind: 'siteDefault' }
  | { readonly kind: 'notOffered'; readonly saved: LanguageChoice; readonly shown: LanguageChoice }
  | { readonly kind: 'onlyOne'; readonly language: LanguageChoice };

export interface LanguageView {
  readonly current: LanguageChoice;
  readonly options: readonly LanguageChoice[];
  readonly note: LanguageNote;
}

const NO_NOTE: LanguageNote = { kind: 'none' };
const SITE_DEFAULT: LanguageNote = { kind: 'siteDefault' };

const noteOf = ({ saved, effective, offered }: SettingsLanguage): LanguageNote => {
  if (saved !== null && !offered.includes(saved)) return { kind: 'notOffered', saved, shown: effective };
  if (offered.length === 1) return { kind: 'onlyOne', language: effective };
  return saved === null ? SITE_DEFAULT : NO_NOTE;
};

export const languageViewOf = (fallback: LanguageChoice, settings: SettingsLanguage | null): LanguageView => {
  if (settings === null) return { current: fallback, options: LANGUAGE_CHOICES, note: NO_NOTE };
  return { current: settings.effective, options: settings.offered, note: noteOf(settings) };
};
